import { createContext, forwardRef, useMemo } from 'react';
import type { ReactNode } from 'react';

export interface DatePickerCustomInputProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  value?: string;
}

export const DatePickerCustomInputContext = createContext<{
  onClick?: () => void;
  value?: string;
}>({
  onClick: undefined,
  value: undefined
});

export const DatePickerCustomInput = forwardRef<
  HTMLDivElement,
  DatePickerCustomInputProps
>(
  (
    { children, className, onClick, value }: DatePickerCustomInputProps,
    ref
  ) => {
    const context = useMemo(() => {
      return {
        onClick,
        value
      };
    }, [onClick, value]);

    return (
      <DatePickerCustomInputContext.Provider value={context}>
        <div className={className} ref={ref}>
          {children}
        </div>
      </DatePickerCustomInputContext.Provider>
    );
  }
);

DatePickerCustomInput.defaultProps = {
  className: undefined,
  onClick: undefined,
  value: undefined
};
